import React from 'react';
import {
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    Box,
    Typography
} from '@mui/material';
import ResponsiveDialog from './ResponsiveDialog';

interface ConfirmationModalProps {
    open: boolean;
    title: string;
    message: string;
    confirmLabel?: string;
    cancelLabel?: string;
    onConfirm: () => void;
    onCancel: () => void;
    isDestructive?: boolean;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
    open,
    title,
    message,
    confirmLabel = 'Confirm',
    cancelLabel = 'Cancel',
    onConfirm,
    onCancel,
    isDestructive = false
}) => {
    return (
        <ResponsiveDialog
            open={open}
            onClose={onCancel}
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    padding: 1,
                    minWidth: '320px',
                    maxWidth: '480px',
                    overscrollBehavior: 'contain',
                }
            }}
        >
            <DialogTitle sx={{ pb: 1, fontWeight: 'bold', fontSize: '1.25rem' }}>
                {title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText sx={{ color: '#4a4a4a', fontSize: '1rem' }}>
                    {message}
                </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2, pt: 1 }}>
                <Button
                    onClick={onCancel}
                    variant="outlined"
                    sx={{
                        borderRadius: 2,
                        textTransform: 'none',
                        fontWeight: 600,
                        color: '#666',
                        borderColor: '#ddd',
                        '&:hover': {
                            borderColor: '#bbb',
                            backgroundColor: '#f5f5f5'
                        }
                    }}
                >
                    {cancelLabel}
                </Button>
                <Button
                    onClick={onConfirm}
                    variant="contained"
                    color={isDestructive ? "error" : "primary"}
                    sx={{
                        borderRadius: 2,
                        textTransform: 'none',
                        fontWeight: 600,
                        boxShadow: 'none',
                        ...(isDestructive ? {} : {
                            backgroundColor: '#533B7D',
                            '&:hover': {
                                backgroundColor: '#422F64',
                            }
                        })
                    }}
                >
                    {confirmLabel}
                </Button>
            </DialogActions>
        </ResponsiveDialog>
    );
};

export default ConfirmationModal;
